module.exports = __webpack_public_path__ + "static/media/eye-gray.91873021.svg";